
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util';
import AbpBase from '../../../lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import vueformmodel from '../../../lib/vueformmodel';
import { FormItem } from 'view-design';
@Component
export default class suppliermanageaddoredit extends vueformmodel {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop() id: number | undefined;
    model: proxy.MerchantRevAccountDto = new proxy.MerchantRevAccountDto();
    get prox() {
        return new proxy.MerchantRevAccountServiceProxy();
    }

    save() {
        (this.$refs.roleForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.prox.createOrUpdate(this.model).then(() => {
                    (this.$refs.roleForm as any).resetFields();
                    this.$Notice.success({ title: '保存成功' });
                    this.$emit('save-success');
                    this.$emit('input', false);
                });
            }
        });
    }
    cancel() {
        (this.$refs.roleForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {
            this.clear();
            this.prox.queryModel(this.id).then(x => {
                this.model = x;
            });
        }
    }
    clear() {

    }
    roleRule = {
        suppName: [
            {
                required: true,
                message: this.L('FieldIsRequired'),
                trigger: 'blur'
            }
        ]
    };
}
